<!-- fixme: should use a component factory so the component can truly be removed -->
@if (!closed()) {
  <div class="fixed z-20 w-full p-2">
    @if (type(); as type) {
      @if (type == "info") {
        <p
          class="w-full border border-solid border-primary-500 px-4 py-2 text-primary-500 font-semibold bg-primary-50 rounded-md flex gap-2 items-start justify-between"
        >
          <span>
            <ng-content></ng-content>
          </span>
          <button (click)="closeClicked()" class="hover:text-primary-900">
            <mat-icon>close</mat-icon>
          </button>
        </p>
      } @else if (type == "success") {
        <p
          class="w-full border border-solid border-lime-500 px-4 py-2 text-lime-500 font-semibold bg-lime-50 rounded-md flex gap-2 items-start justify-between"
        >
          <span>
            <ng-content></ng-content>
          </span>
          <button (click)="closeClicked()" class="hover:text-primary-900">
            <mat-icon>close</mat-icon>
          </button>
        </p>
      } @else if (type == "danger") {
        <p
          class="w-full border border-solid border-accent-500 px-4 py-2 text-accent-500 font-semibold bg-accent-50 rounded-md flex gap-2 items-start justify-between"
        >
          <span>
            <ng-content></ng-content>
          </span>
          <button (click)="closeClicked()" class="hover:text-primary-900">
            <mat-icon>close</mat-icon>
          </button>
        </p>
      } @else if (type == "warning") {
        <p
          class="w-full border border-solid border-yellow-500 px-4 py-2 text-yellow-500 font-semibold bg-yellow-50 rounded-md flex gap-2 items-start justify-between"
        >
          <span>
            <ng-content></ng-content>
          </span>
          <button (click)="closeClicked()" class="hover:text-primary-900">
            <mat-icon>close</mat-icon>
          </button>
        </p>
      } @else if (type == "primary") {
        <p
          class="w-full border border-solid border-primary-500 px-4 py-2 text-primary-500 font-semibold bg-primary-50 rounded-md flex gap-2 items-start justify-between"
        >
          <span>
            <ng-content></ng-content>
          </span>
          <button (click)="closeClicked()" class="hover:text-primary-900">
            <mat-icon>close</mat-icon>
          </button>
        </p>
      } @else if (type == "secondary") {
        <p
          class="w-full border border-solid border-secondary-500 px-4 py-2 text-secondary-500 font-semibold bg-secondary-50 rounded-md flex gap-2 items-start justify-between"
        >
          <span>
            <ng-content></ng-content>
          </span>
          <button (click)="closeClicked()" class="hover:text-primary-900">
            <mat-icon>close</mat-icon>
          </button>
        </p>
      } @else {
        <p
          class="w-full border border-solid border-primary-500 px-4 py-2 text-primary-500 font-semibold bg-primary-50 rounded-md flex gap-2 items-start justify-between"
        >
          <span>
            <ng-content></ng-content>
          </span>
          <button (click)="closeClicked()" class="hover:text-primary-900">
            <mat-icon>close</mat-icon>
          </button>
        </p>
      }
    } @else {
      <p
        class="w-full border border-solid border-primary-500 px-4 py-2 text-primary-500 font-semibold bg-primary-50 rounded-md flex gap-2 items-start justify-between"
      >
        <span>
          <ng-content></ng-content>
        </span>
        <button (click)="closeClicked()" class="hover:text-primary-900">
          <mat-icon>close</mat-icon>
        </button>
      </p>
    }
  </div>
}
